import './whatsapp_media_message_content.js.coffee'

Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.WhatsappVideoMessageContent extends Monitoring.Models.SocialContents.WhatsappMediaMessageContent

  getVideoCaption: ->
    @json.whatsappMessage.caption

  getMainText: ->
    @json.whatsappMessage.caption
